import axios from 'axios'
const api = "configurar"

const cedisInventarioDiferente = {
    getCedis: () => axios.get(`${api}/get-cedis-inventario`),
    putCedisInventario: (idCedis,params) => axios.put(`${api}/${idCedis}/set-cedis-inventario`,params)
}
export default cedisInventarioDiferente